<template>
  <div class="participant-response-query-comment pl-16 pr-16 pt-24 mb-4">
    <div class="participant-response-query-comment__time-container mb-9">
      <span class="participant-response-query-comment__time">{{ comment.created_time | formatGMTDate }}</span>
    </div>
    <div class="participant-response-query-comment__name mt-5 fs-14">
      {{ comment.issuer }}
      <span v-if="comment.issuer_role === 'Cra'">(CRA(B))</span>
      <span v-else-if="comment.issuer_role === 'CraUB'">(CRA(U))</span>
      <span v-else>({{ comment.issuer_role | uppercase }})</span>
    </div>
    <div class="participant-response-query-comment__text mt-5 fs-14">
      {{ comment.notes }}
    </div>
  </div>
</template>

<script>
export default {
  name: "participant-activity-response-comment-item",
  props: {
    comment: {
      type: Object
    }
  }
};
</script>

<style lang="scss" scoped>
.participant-response-query-comment {
  &__time-container {
    color: #959fa4;
    font-size: 11px;
  }

  &__name {
    color: #4a4a4a;
    font-weight: bold;
  }

  &__text {
    color: #000000;
  }

  &__link {
    width: 31px;
    height: 14px;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: normal;
    color: #4c8ce4;
  }

  &-detailed-reply-btn {
    width: 83.9px;
    height: 23.9px;
    font-family: Roboto;
    font-size: 12px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #4c8ce4;
  }
}
</style>
